export interface ReferralProgress {
	monthsEarned: number;
	progressInCurrentGroup: number;
	groupSize: number;
	remaining: number;
	isInPhase1: boolean;
}

// Phase 1: first 2 referrals -> 1 free month each (bonus tier)
// Phase 2: every 3 referrals -> 1 free month (standard tier)
export function getReferralProgress(validReferrals: number): ReferralProgress {
	if (validReferrals < 2) {
		return {
			monthsEarned: validReferrals,
			progressInCurrentGroup: validReferrals,
			groupSize: 2,
			remaining: 2 - validReferrals,
			isInPhase1: true,
		};
	}

	const beyondPhase1 = validReferrals - 2;
	const progressInGroup = beyondPhase1 % 3;

	return {
		monthsEarned: 2 + Math.floor(beyondPhase1 / 3),
		progressInCurrentGroup: progressInGroup,
		groupSize: 3,
		remaining: 3 - progressInGroup,
		isInPhase1: false,
	};
}
